import React from 'react';
import classnames from 'classnames';
import * as _ from 'lodash';
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';
import styles from './styles.module.scss';

const Section8Text14 = React.forwardRef(({}, ref) => {
  const context = useCompleteInspectionContext();
  const {
    identifyMethodType,
    joinHomeRegistryDate,
    joinHomeRegistryNotes,
    joinHomeRegistryMortgage
  } = context.data.pdfData;

  const showText = _.some([
    joinHomeRegistryDate,
    joinHomeRegistryNotes,
    joinHomeRegistryMortgage
  ]);

  return (
    <div ref={ref}>
      {showText && identifyMethodType === 2 && (
        <div className={classnames(styles.itemText, styles.innerPadding)}>
          <span className={classnames(styles.bold, styles.underline)}>נסח רישום מפנקס הזכויות:</span>
        </div>
      )}
    </div>
  );
});

export default Section8Text14;
